import Validator from '@shared/validatorjs/src/validator'
import {
  UpdateUISettingsRequest,
  UpdateField,
  FetchUISettingsRequest,
} from './ui-settings.actions'
import { getFormsState } from '../forms/forms.selectors'
import FormTrait from 'src/app/traits/form.trait'
import { getUISettingsState } from './ui-settings.selectors'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { select, Store } from '@ngrx/store'
import { fromJS, Map } from 'immutable'
import { fileToBase64 } from '@shared/shared.utils'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-ui-settings',
  templateUrl: './ui-settings.component.html',
  styleUrls: ['./ui-settings.component.css'],
})
export class UISettingsComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  public isLoading: boolean
  public initialLoginLogo: any
  public initialReportLogo: any

  constructor(
    public store: Store<any>,
    private translateService: TranslateService,
  ) {
    super()
  }

  ngOnInit() {
    this.state$ = this.store
      .pipe(select(getUISettingsState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')

        if (
          this.initialLoginLogo === undefined &&
          this.getField(['SETTINGS_UI_LOGIN_LOGO']) !== ''
        ) {
          this.initialLoginLogo =
            this.getField(['SETTINGS_UI_LOGIN_LOGO']) || null
        }

        if (
          this.initialReportLogo === undefined &&
          this.getField(['SETTINGS_UI_REPORT_LOGO']) !== ''
        ) {
          this.initialReportLogo =
            this.getField(['SETTINGS_UI_REPORT_LOGO']) || null
        }
      })

    this.store.dispatch(new FetchUISettingsRequest())
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(name || e.target.name, name ? e : e.target.value, 'data'),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        '',
      ),
    )
  }

  public checkboxChange(e: any, name?: string): void {
    this.store.dispatch(
      new UpdateField(name || e.target.name, e.target.checked, 'data'),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      SETTINGS_UI_TITLE: 'required',
      SETTINGS_UI_DESCRIPTION: 'required',
    }
    const validator = new Validator(data.toJS(), rules)

    validator.setAttributeNames({
      SETTINGS_UI_TITLE: 'title',
      SETTINGS_UI_DESCRIPTION: 'description',
    })

    return validator
  }

  public async onFileChange({ event, field }: any) {
    if (event.target.files.length) {
      const file = event.target.files[0] as File
      const base64 = await fileToBase64(file)
      const maxSize = 8 * 1024 * 1024 // 8 MB

      if (file.size <= maxSize) {
        this.handleFieldChange(
          {
            base64,
            fileName: file.name,
            contentType: file.type,
          },
          field,
        )
      } else {
        this.store.dispatch<any>(
          new UpdateField(
            `${field}`,
            [this.translateService.instant('MAX_FILE_SIZE_8_MB')],
            'validationErrors',
          ),
        )
      }
    } else {
      this.handleFieldChange(null, field)
    }
  }

  public onImageDelete(field) {
    this.handleFieldChange(
      {
        deleted: true,
      },
      field,
    )
  }

  public getImageUrl(data: any) {
    if (data) {
      return `data:${data.get('contentType')};base64,${data.get('base64')}`
    }

    return ''
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      if (!!payload.SETTINGS_UI_LOGIN_LOGO) {
        if (
          JSON.stringify(this.initialLoginLogo) ===
          JSON.stringify(payload.SETTINGS_UI_LOGIN_LOGO)
        ) {
          payload.SETTINGS_UI_LOGIN_LOGO = null
        }
      } else {
        if (!!this.initialLoginLogo) {
          payload.SETTINGS_UI_LOGIN_LOGO = { deleted: true }
        } else {
          payload.SETTINGS_UI_LOGIN_LOGO = null
        }
      }

      if (!!payload.SETTINGS_UI_REPORT_LOGO) {
        if (
          JSON.stringify(this.initialReportLogo) ===
          JSON.stringify(payload.SETTINGS_UI_REPORT_LOGO)
        ) {
          payload.SETTINGS_UI_REPORT_LOGO = null
        }
      } else {
        if (!!this.initialReportLogo) {
          payload.SETTINGS_UI_REPORT_LOGO = { deleted: true }
        } else {
          payload.SETTINGS_UI_REPORT_LOGO = null
        }
      }

      this.store.dispatch(new UpdateUISettingsRequest(payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, ''),
      )
    }
  }
}
